import { Button } from 'antd';
import router from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { WebPNextImage as Image } from '../../WebPImage';

import style from './style.module.scss';

export default function Success({ text }) {
  const [time, setTime] = useState(5);

  let timer = useRef(null);
  useEffect(() => {
    if (time === 5)
      timer.current = setInterval(() => setTime((t) => t - 1), 1000);
    else if (time <= 0) {
      clearInterval(timer.current);
      goBack();
    }
  }, [time]);

  const goBack = () => {
    router.push('/');
  };

  return (
    <div className={style['success-container']}>
      <Image
        src={'/img/success.webp'}
        alt="sucess"
        width={66}
        height={66}
      ></Image>
      <div className={style['success-text']}>
        <div>{text}</div>
        <div className={style['success-hint']}>
          {time}s后自动跳转回首页，也可手动跳转
        </div>
      </div>
      <Button className={style['goback-btn']} onClick={() => goBack()}>
        返回首页
      </Button>
    </div>
  );
}
